// extracted by mini-css-extract-plugin
export default {"ma-tabs":"MaTabs_ma-tabs__rrZ2f","tabs":"MaTabs_tabs__eHyi5"};